/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.contact.dismissMatch'

export { $nsid }

/** Removes a match that was found via contact import. It shouldn't appear again if the same contact is re-imported. Requires authentication. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({ subject: l.string({ format: 'did' }) }),
  l.jsonPayload({}),
  ['InvalidDid', 'InternalError'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
